/**
 * DataCardRow primitive — structured row within a DataCard for label-value pairs.
 * Uses Tailwind design tokens — no hardcoded hex colors.
 */
import React from 'react';

export interface DataCardRowProps {
  label: string;
  value: string;
  variant?: 'primary' | 'secondary' | 'muted';
}

export function DataCardRow({ label, value, variant = 'primary' }: DataCardRowProps): React.ReactElement {
  const variantClasses: Record<string, string> = {
    primary: 'text-gray-900 dark:text-gray-100',
    secondary: 'text-gray-700 dark:text-gray-300',
    muted: 'text-gray-500 dark:text-gray-400',
  };

  return (
    <div className="flex items-center justify-between py-2">
      <span className="text-sm text-gray-500 dark:text-gray-400">{label}</span>
      <span className={`text-sm font-medium ${variantClasses[variant]}`}>{value}</span>
    </div>
  );
}
